
  async function checkLive() {
    let res = await fetch('https://id.twitch.tv/oauth2/token?client_id=0t42accmia4wumethqhg9mlqzn5ctq&client_secret=7bs3w5gy4rfbcpcl5ozpdxiwfh8yva&grant_type=client_credentials', {
      method: 'POST'
    })
    let data = await res.json()

    if(data && data['access_token']) {
      res = await fetch('https://api.twitch.tv/helix/streams?user_login=gebauermarc', {
        headers: {
          'Client-ID' : '0t42accmia4wumethqhg9mlqzn5ctq',
          'Authorization' : 'Bearer ' + data['access_token'],
        }
      })

      data = await res.json()
      let availableUnavailables = document.querySelectorAll('.twitch-live-indicator')

      if(data['data'].length > 0) 
        for(let i = 0; i < availableUnavailables.length; i++) availableUnavailables[i].classList.add('available')
      else 
        for(let i = 0; i < availableUnavailables.length; i++) availableUnavailables[i].classList.remove('available')
    }
  }

  window.addEventListener('load', () => {
    let h = document.getElementById('twitch-indicator-hook')
    if(h) {
      h.outerHTML = '<a target="_blank" href="https://www.twitch.tv/gebauermarc" class="twitch-live-indicator br"> <img style="max-width: 100%; height: auto;" src="//www.marcgebauer.com/cdn/shop/files/marc-is-live-vertical.png?v=1787159383" alt="Marc is live on twitch!"> </a>'
    }

    checkLive()
    setInterval(checkLive, 60000);
  })


